// NPM Imports
import React, { Component } from "react";
import Modal from "react-responsive-modal";
import { connect } from "react-redux";
import { Button } from "../../../revvComponents";

// Components Imports

// Action Imports
import { QuotationActions } from "../../../actions";
import { updateComponentMeta } from "../../../actions/DocumentActions/index";

import { convertSectionTableToQuoteTable } from "../utils";

// Action Imports
const { toggleTabAndToolPanelData } = QuotationActions;

const QUOTE_TABLE = "QUOTE_TABLE";

class TableToQuoteConfirmationPopup extends Component {
  state = {};

  _closePopup = () => {
    this.props.updateMultipleState({
      showTabletoQuoteConfirmation: false,
    });
  };

  _handleConfirmation = () => {
    this.props.updateComponentMeta({});
    const updatedTableData = convertSectionTableToQuoteTable(
      this.props.currentSection,
    );
    this.props.saveTable(updatedTableData);
    if (!this.props.isSharedDocument && !this.props.dealTableId) {
      this.props.toggleTabAndToolPanelData({
        tabView: QUOTE_TABLE,
        dealTableId: 0,
        isOpen: false,
        panelView: null,
        page: QUOTE_TABLE,
        showPriceBook: true,
      });
    }
  };

  render() {
    return (
      <Modal open onClose={this._closePopup} closeOnOverlayClick={false} center>
        <div
          className="modal-container table-gsheet-popup-container"
          data-test="table-gsheet-popup-container">
          <div
            className="modal-heading table-to-gsheet-heading"
            data-test="table-gsheet-popup-modal-heading">
            <span role="img" aria-label="">
              ⚠️
            </span>{" "}
            <span>Importing data will replace existing data</span>
          </div>
          <div className="modal-form">
            <div
              className="modal-form-field"
              data-test="table-gsheet-popup-form">
              You&apos;re about to link this table to a Quote table. Any
              existing data will be replaced by imported data.
            </div>
          </div>

          <div className="modal-footer">
            <Button
              className="btn btn-transparent modal-footer-btn cancle-btn"
              data-test="table-gsheet-popup-cancle-btn"
              onClick={this._closePopup}>
              Go back
            </Button>
            <Button
              className="btn btn-primary modal-footer-btn submit-btn"
              data-test="table-gsheet-popup-submit-btn"
              onClick={() => this._handleConfirmation()}>
              Continue
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const { activeComponentMeta, components } = state.DocumentStore;
  const { dealTableId } = state.QuotationStore;
  return {
    currentSection: components[activeComponentMeta.componentId],
    dealTableId,
  };
};

const mapDispatchToProps = {
  toggleTabAndToolPanelData,
  updateComponentMeta,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TableToQuoteConfirmationPopup);
